var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnDownloadCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.5C8.68003 5.5 6.92382 7.96047 6.46816 9.17556L6.3465 9.5H6C5.33698 9.5 4.19999 9.72651 3.24123 10.4597C2.3073 11.1739 1.5 12.3995 1.5 14.5C1.5 15.5479 2.13493 16.547 3.01497 17.3097C3.44885 17.6857 3.92476 17.9879 4.37313 18.1942C4.82863 18.4039 5.22335 18.5 5.5 18.5H19C19.5737 18.5 20.4565 18.3018 21.1853 17.7115C21.8929 17.1383 22.5 16.1605 22.5 14.5C22.5 13.8225 22.186 13.0655 21.6345 12.4747C21.0875 11.8888 20.3389 11.5 19.5 11.5H18.1096L18.0149 11.1213C17.7721 10.1501 17.2942 8.73061 16.3596 7.56235C15.4394 6.41217 14.0756 5.5 12 5.5ZM5.66213 8.51355C6.35942 6.9994 8.38095 4.5 12 4.5C14.4244 4.5 16.0606 5.58783 17.1404 6.93765C18.0823 8.11503 18.5996 9.48687 18.8845 10.5H19.5C20.6611 10.5 21.6625 11.0393 22.3655 11.7923C23.064 12.5406 23.5 13.5336 23.5 14.5C23.5 16.4395 22.7737 17.7117 21.8147 18.4885C20.8769 19.2482 19.7596 19.5 19 19.5H5.5C5.02665 19.5 4.48387 19.3461 3.95499 19.1026C3.41899 18.8559 2.86365 18.5018 2.36003 18.0653C1.36507 17.203 0.5 15.9521 0.5 14.5C0.5 12.1005 1.4427 10.5761 2.63377 9.66532C3.65392 8.88521 4.82463 8.57822 5.66213 8.51355Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 13L9 13L12 16L15 13L13 13L13 9.5L11 9.5L11 13Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDownloadCloud);
export default __webpack_public_path__ + "static/media/icn-download-cloud.3fed9887.svg";
export { ForwardRef as ReactComponent };